/* src/app/components/payroll/payroll-tabs-layout/payroll-tabs-layout.component.css */
:host {
  display: block;
  --payroll-tabs-height: 52px;
}
.payroll-tabs {
  height: var(--payroll-tabs-height);
  margin-top: 50px;
  padding: 10px 12px 0 12px;
  box-sizing: border-box;
}
.payroll-tabs .ppl-nav-tabs {
  justify-content: flex-start;
  margin: 0;
  height: 100%;
}
.payroll-tabs .ppl-nav-item {
  flex: 0 1 180px;
}
:host.has-tabs ::ng-deep .ppl-container-body {
  margin-top: 0;
  height: calc(100vh - 120px - var(--payroll-tabs-height));
}
:host.has-tabs ::ng-deep .ppl-container-body > .ppl-container {
  min-height: calc(100vh - 180px - var(--payroll-tabs-height));
}
/*# sourceMappingURL=payroll-tabs-layout.component-TENVBKRY.css.map */
